import {createParsedFeatureNode} from "../../utils/createParsedFeatureNode";
import {fromJS} from "immutable";
import {createPointSourceFeature} from "../../utils/createPointSourceFeature";
import {GEO_TYPES, getGeoType} from "../../utils/getGeoType";
import {IApplicationState} from "../types";
import {Feature} from "geojson";
import {createSource} from "../../utils/createSource";
import {createFeatureCollection} from "../../utils/createFeatureCollection";
import {Reducer} from "redux";
import {IFeature_CONO} from "../../types";

const createFeature: Reducer<IApplicationState['map']> = (state, action) => {
    let mapStyle = state?.mapStyle;
    let {fullUid, type, feature = {}, entity} = action.payload;
    feature = createSourceFeature(feature);
    const newFeature = createParsedFeatureNode(feature, entity);
    const fPath = ['sources', type, 'data', 'features'];
    let features = mapStyle?.getIn(fPath);
    if (!features || features.size === 0) {
        mapStyle = mapStyle?.setIn(['sources', type],
            fromJS(createSource(createFeatureCollection([]) as any)));
        features = mapStyle?.getIn(fPath);
    } else {
        features = features.filter((f: any) => f.getIn(['properties', 'fullUid']) !== fullUid);
    }

    features = features.push(fromJS(newFeature));
    mapStyle = mapStyle?.setIn([...fPath], features);
    return {...state, mapStyle} as IApplicationState['map'];
}

function createSourceFeature (feature: IFeature_CONO) {
    const geoType = getGeoType(feature);
    if (!feature.properties) {
        (feature as Feature).properties = {};
    }
    if (geoType === GEO_TYPES.Point) {
        feature = createPointSourceFeature(feature);
    }
    return feature;
}

export { createFeature };
